import { UserJob } from '../../../../../lib/interfaces/user';
import { Checkbox } from '../../../../../ui/components/ui/checkbox';
import { SELECTABLE_USER_JOBS, USER_JOB_LABELS } from '../../../constants/user-job-labels';

export interface AudienceSelectorValue {
  allJobs: boolean;
  userJobs: UserJob[];
}

export interface AudienceSelectorProps {
  value: AudienceSelectorValue;
  onChange: (next: AudienceSelectorValue) => void;
  disabled?: boolean;
}

const AudienceSelector = ({ value, onChange, disabled }: AudienceSelectorProps) => {
  const toggleAllJobs = (next: boolean) => {
    onChange({ allJobs: next, userJobs: next ? [] : value.userJobs });
  };

  const toggleJob = (job: UserJob, next: boolean) => {
    if (value.allJobs) return;
    const userJobs = next ? Array.from(new Set([...value.userJobs, job])) : value.userJobs.filter((j) => j !== job);
    onChange({ allJobs: false, userJobs });
  };

  return (
    <div className="flex flex-col gap-3">
      <label className="flex items-center gap-2 cursor-pointer">
        <Checkbox checked={value.allJobs} onCheckedChange={(checked) => toggleAllJobs(checked === true)} disabled={disabled} />
        <span className="text-[14px] text-[#12282A]">Alle Rollen (auch zukünftige)</span>
      </label>
      <div className="grid grid-cols-2 gap-2 pl-1">
        {SELECTABLE_USER_JOBS.map((job) => {
          const checked = value.allJobs || value.userJobs.includes(job);
          const fieldDisabled = disabled || value.allJobs;
          return (
            <label key={job} className={`flex items-center gap-2 ${fieldDisabled ? 'opacity-50' : 'cursor-pointer'}`}>
              <Checkbox checked={checked} onCheckedChange={(next) => toggleJob(job, next === true)} disabled={fieldDisabled} />
              <span className="text-[14px] text-[#12282A]">{USER_JOB_LABELS[job]}</span>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export default AudienceSelector;
